"use client";
/* eslint-disable no-unused-vars */
import { Button } from "@/components";
import { getImageURL } from "@/lib";
export const PrimePageDownloadCenter = ({ data = {} }) => {
    const { heading, image, document, bg_image, list = [] } = data;

    return <></>;
};
